import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const CMSHome = () => {
  const [stats, setStats] = useState({
    total: 0,
    published: 0,
    drafts: 0,
    loading: true,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await api.getPages();
      if (response.success) {
        const pages = response.data || [];
        setStats({
          total: pages.length,
          published: pages.filter(p => p.status === 'published').length,
          drafts: pages.filter(p => p.status === 'draft').length,
          loading: false,
        });
      }
    } catch (error) {
      console.error('Failed to load CMS stats:', error);
      setStats({ ...stats, loading: false });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <div className="info-box">
            <span className="info-box-icon bg-info"><i className="fas fa-file-alt"></i></span>
            <div className="info-box-content">
              <span className="info-box-text">Total Pages</span>
              <span className="info-box-number">{stats.loading ? '...' : stats.total}</span>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="info-box">
            <span className="info-box-icon bg-success"><i className="fas fa-check-circle"></i></span>
            <div className="info-box-content">
              <span className="info-box-text">Published</span>
              <span className="info-box-number">{stats.loading ? '...' : stats.published}</span>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="info-box">
            <span className="info-box-icon bg-warning"><i className="fas fa-edit"></i></span>
            <div className="info-box-content">
              <span className="info-box-text">Drafts</span>
              <span className="info-box-number">{stats.loading ? '...' : stats.drafts}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">CMS Management</h3>
              <div className="card-tools">
                <Link to="/cms/pages" className="btn btn-sm btn-primary">
                  <i className="fas fa-plus"></i> Manage Pages
                </Link>
              </div>
            </div>
            <div className="card-body">
              <p>Manage content for ChesiSite_Web from this portal.</p>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="card card-primary">
                    <div className="card-header">
                      <h3 className="card-title">Pages</h3>
                    </div>
                    <div className="card-body">
                      <p>Create and manage website pages</p>
                      <Link to="/cms/pages" className="btn btn-primary btn-sm">
                        <i className="fas fa-file-alt"></i> Manage Pages
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card card-success">
                    <div className="card-header">
                      <h3 className="card-title">Content</h3>
                    </div>
                    <div className="card-body">
                      <p>Manage content blocks and sections</p>
                      <Link to="/cms/content" className="btn btn-success btn-sm">
                        <i className="fas fa-edit"></i> Manage Content
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CMSHome;


